export const PASSIVE = { passive: true }
export const FF_EXTENSION_TRICK = { x: true }
